import React, { Component } from 'react'

import Item from "./item"

// 기본 데이터 요소
const defaultData = {
  isLink: false,
  isPlus: false,
  isMinus: false,
  isSearch: false,
  isRefresh: false,
  isCheck: false,
  checked: false,
  title : "제목",
  value : "",
  startText : "",
  endText : "",
  placeHolder : "",
  description : "",
  preAddOnSelctbox : ""
}

class InputBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLink : defaultData.isLink,
      isPlus: defaultData.isPlus,
      isMinus : defaultData.isMinus,
      isSearch : defaultData.isSearch,
      isRefresh: defaultData.isRefresh,
      isCheck : defaultData.isCheck,
      checked : defaultData.checked,
      title : defaultData.title,
      value : defaultData.value,
      startText : defaultData.startText,
      endText : defaultData.endText,
      placeHolder : defaultData.placeHolder,
      description : defaultData.description,
      preAddOnSelctbox : defaultData.preAddOnSelctbox,
    }

    // console.log(this.props)
  }

  componentDidMount() {
    this.props.isLink && this.setState({ isLink : true })
    this.props.isPlus && this.setState({ isPlus : true })
    this.props.isMinus && this.setState({ isMinus : true })
    this.props.isSearch && this.setState({ isSearch : this.props.isSearch })
    this.props.isRefresh && this.setState({ isRefresh : true })
    this.props.isCheck && this.setState({ isCheck : true })
    this.props.checked && this.setState({ checked : true })
    this.props.title && this.setState({ title : this.props.title })
    // this.props.value && this.setState({ value : this.props.value })
    this.props.startText && this.setState({ startText : this.props.startText })
    this.props.endText && this.setState({ endText : this.props.endText })
    this.props.placeHolder && this.setState({ placeHolder : this.props.placeHolder })
    this.props.description && this.setState({ description : this.props.description })
    this.props.preAddOnSelctbox && this.setState({ value : this.props.preAddOnSelctbox })

    //배열 키값 생성
    let tempValue = [];

    this.props.value && (
      this.props.value.map((data, idx) => {
        tempValue.push({id : idx, value : data.value})
      })
    )
    
    this.setState({ value : tempValue })
  }

  clickEvent = (type) => {
    switch(type)
    {
      case "search":
        () => this.props.isSearch
        break;
    }

    // console.log(type)
    // console.log("click event")
  }

  addInput = () => {
    let chkID = 0

    chkID = this.state.value[ this.state.value.length - 1 ].id + 1

    this.setState({
      value : this.state.value.concat({ id : chkID , value : "" })
    })
  }

  removeInput = (refName) => {
    let refData = this.refs[refName]
    
    if (refData) {
      this.setState({
        value : this.state.value.filter(f => "ref" + f.id != refName)
      })
    }
  }

  render() {
    return (
      <div className="form-group">
        {
          this.props.title &&(
            <label htmlFor="input"><strong>{this.state.title}</strong></label>
          )
        }
        {
          this.state.value.length > 1 ?
          this.state.value.map((data, idx) => {
            return (
              <Item 
                key={data.id}
                index={data.id}
                ref={"ref" + data.id}
                title={"ref" + data.id}
                name={this.state.title}
                value={data.value}
                isLink={this.state.isLink}
                isPlus={this.state.isPlus}
                isMinus={this.state.isMinus}
                isSearch={this.state.isSearch}
                isRefresh={this.state.isRefresh}
                isCheck={this.state.isCheck}
                checked={this.state.checked}
                length={this.state.value.length}
                startText={this.state.startText}
                endText={this.state.endText}
                placeHolder={this.state.placeHolder}
                description={this.state.description}
                preAddOnSelctbox={this.state.preAddOnSelctbox}
                addInputEvent={this.addInput}
                removeInputEvent={this.removeInput}
              />
            )
          }) :
          <Item 
            ref={"ref0"}
            value={this.props.value && this.props.value[0].value}
            isLink={this.props.isLink}
            isPlus={this.props.isPlus}
            isMinus={this.props.isMinus}
            isSearch={this.props.isSearch}
            isRefresh={this.props.isRefresh}
            isCheck={this.props.isCheck}
            checked={this.props.checked}
            startText={this.props.startText}
            endText={this.props.endText}
            placeHolder={this.props.placeHolder}
            description={this.props.description}
            preAddOnSelctbox={this.props.preAddOnSelctbox}
            addInputEvent={this.addInput}
            removeInputEvent={this.removeInput}
          />
        }
      </div>
    )
  }
}

export default InputBox;
